import { GLOBAL_ACTIONS, GLOBAL_RESOURCES } from 'src/constants';
import { EvaluationInfo } from 'src/types/rest/managementPortalApi';

export interface RefinedEvaluationInfo extends EvaluationInfo {
  action: {
    name: (typeof GLOBAL_ACTIONS)[keyof typeof GLOBAL_ACTIONS];
  };
  resource: {
    type: (typeof GLOBAL_RESOURCES)[keyof typeof GLOBAL_RESOURCES];
  };
}

export const createEvaluationInfo = (
  name: RefinedEvaluationInfo['action']['name'],
  type: RefinedEvaluationInfo['resource']['type'],
): RefinedEvaluationInfo => ({ action: { name }, resource: { type } });
